<script>
  import Footer from "./Footer.svelte";
</script>

<div class="section">
  <div class="content">
    <slot></slot>
  </div>
</div>
<Footer></Footer>

<style>
  .section {
    width: 100%;
    max-width: var(--max-width);
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding: var(--main-gutter);
    padding-top: var(--main-gutter-vertical);
    padding-bottom: var(--main-gutter-vertical);
    flex-direction: column;
    /* border-bottom: 1px solid black; */
    font-size: 16px;
    /* line-height: 1.5; */
    /* border-bottom: 1px solid black; */
  }
  .content {
    max-width: 800px;
  }
  /* :global(.section .content p) {
    margin: 0;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  :global(.section .content p + p) {
    margin: 0;
    margin-top: 10px;
    margin-bottom: 0px;
  } */
</style>
